
export const poiApiNm = {
  getPOI: "/poi/getPOI",
  getPOIInBond: "/poi/getPOIInBond",
  getDistance: "/poi/getDistance",
  getDistanceFromCompany: "/poi/getDistanceFromCompany",
  getDistanceFromCompanyToPOIId: "/poi/getDistanceFromCompanyToPOIId",
  insertPOI: "/poi/insertPOI",
  updatePOI: "/poi/updatePOI",
  updatePOIColumn: "/poi/updatePOIColumn",
  deletepoi: "/poi/deletepoi",
  fetchPOIFromDTC: "/poi/fetchPOIFromDTC",
}
export const poiColNm =  {
  Name: "ชื่อสถานที่",
  SName: "ชื่อย่อ",
  InvNm: "ชื่อสำหรับใบแจ้งหนี้",
  AltNms: "ชื่อเรียกอื่นๆ",
  Addr: "ที่อยู่",
  Tel: "เบอร์โทรศัพท์",
  Lat: "ละติจูด",
  Lng: "ลองจิจูด",
  POITypId: "ประเภทสถานที่",
  Rad: "รัศมี",
  PoiTypNm: "ประเภทสถานที่",
  Rmk: "หมายเหตุ",
  Dist: "ระยะทาง",
  Prty: "Priority",
}